import React from "react";

import svg from "../../assets/images/icons/steps/Run Rule Table.svg";

export const RunTableRuleIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Rule Table"}
    />
);
